export default __webpack_public_path__ + "static/media/chiclayo-pov.2f5bb86a.jpg";